import _ from 'lodash';

import {
    PRIVACY_POLICY_SECTION
} from '../actions/Types';

export default (state = {}, action) => {
    switch (action.type) {
        case PRIVACY_POLICY_SECTION:
            return {...state, ..._.mapKeys(action.payload, 'id')};
        default:
            return state;
    }
}